<template>
	<transition 
			appear
			:appear-active-class="$_wndLyt_stylePageLayoutAnimation()">
		<v-row class="customVRow" no-gutters>
			<v-col>
				<v-window
						continuous
						dark
						light
						:next-icon="'keyboard_arrow_right'"
						:prev-icon="'keyboard_arrow_left'"
						show-arrows
						show-arrows-on-hover
						touchless
						vertical>
					<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
						<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
							<v-window-item :key="contentKey">
								<v-sheet
										class="customVSheet"
										:color="$_wndLyt_styleSheetColor"
										:dark="$_wndLyt_styleSheetDark"
										:elevation="$_wndLyt_styleSheetElevation"
										:light="$_wndLyt_styleSheetLight">
									<v-card	class="customVCard"
											color="transparent"
											flat>
										<template v-if="isObject(contentVals.bigImage)">
											<v-row>
												<v-col>
													<v-img	class="customVImg"
															:src="$_wndLyt_styleContentBigImageUrl(contentVals)" />
												</v-col>
											</v-row>
										</template>
										<template v-if="isObject(contentVals.bigChart)">
											<v-row>
												<v-col>
													<card-big-chart
															:contentKey="contentKey"
															:contents="contents"
															:inits="inits" />
												</v-col>
											</v-row>
										</template>
										<v-row>
											<template v-if="isObject(contentVals.image)">
												<v-col cols="12" md="4" class="center">
													<v-img	class="customVImg"
															:src="$_wndLyt_styleContentImageUrl(contentVals)" />
												</v-col>
											</template>
											<v-col>
												<template v-if="contentVals.title">
													<v-row no-gutters>
														<v-col>
															<v-card-title>
																<span v-html="$_wndLyt_langContentTitle(contentVals)" />
															</v-card-title>
														</v-col>
													</v-row>
												</template>
												<template v-if="!isFalse($_wndLyt_langContentText(contentVals))">
													<v-row no-gutters>
														<v-col>
															<v-card-text>
																<span	class="markdown"
																		v-html="marked($_wndLyt_langContentText(contentVals))" />
															</v-card-text>
														</v-col>
													</v-row>
												</template>
												<template v-if="contentVals.actionButtons">
													<v-row no-gutters>
														<v-col>
															<v-card-actions>
																<v-row dense>
																	<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
																		<v-col :key="actionButtonKey" cols="auto">
																			<v-btn	class="customVBtn"
																					:block="$_wndLyt_styleActionButtonBlock"
																					:color="$_wndLyt_styleActionButtonColor"
																					:dark="$_wndLyt_styleActionButtonDark"
																					:depressed="$_wndLyt_styleActionButtonDepressed"
																					:elevation="$_wndLyt_styleActionButtonElevation"
																					:large="$_wndLyt_styleActionButtonLarge"
																					:light="$_wndLyt_styleActionButtonLight"
																					:outlined="$_wndLyt_styleActionButtonOutlined"
																					:rounded="$_wndLyt_styleActionButtonRounded"
																					:small="$_wndLyt_styleActionButtonSmall"
																					:text="$_wndLyt_styleActionButtonFlat"
																					@click="openLink(actionButtonVals.link)"
																					v-text="$_wndLyt_langActionButtonTitle(actionButtonVals)" />
																		</v-col>
																	</template>
																</v-row>
															</v-card-actions>
														</v-col>
													</v-row>
												</template>
											</v-col>
											<template v-if="isObject(contentVals.chart)">
												<v-col cols="12" md="6" class="center">
													<card-chart
															:contentKey="contentKey"
															:contents="contents"
															:inits="inits" />
												</v-col>
											</template>
										</v-row>
									</v-card>
								</v-sheet>
							</v-window-item>
						</template>
					</template>
				</v-window>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'WindowLayout',
		props: {
			inits: Object,
			contents: Object
		},
		data() {
			return {
				window: null
			}
		},
		computed: {
			// state
			$_wndLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// info
			$_wndLyt_infoInterval() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.inits, 'interval')
			},
			// lang
			// (content)
			$_wndLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_wndLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_wndLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_wndLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_wndLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_wndLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_wndLyt_styleSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'sheet')
			},
			$_wndLyt_styleSheetColor() {
				const self_ = this;
				const sheet_ = self_.$_wndLyt_styleSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.color)
			},
			$_wndLyt_styleSheetDark() {
				const self_ = this;
				const sheet_ = self_.$_wndLyt_styleSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.dark)
			},
			$_wndLyt_styleSheetElevation() {
				const self_ = this;
				const sheet_ = self_.$_wndLyt_styleSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.elevation)
			},
			$_wndLyt_styleSheetLight() {
				const self_ = this;
				const sheet_ = self_.$_wndLyt_styleSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.dark)
			},
			$_wndLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_wndLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_wndLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_wndLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_wndLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_wndLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_wndLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_wndLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_wndLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_wndLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_wndLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_wndLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_wndLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_wndLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_wndLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_wndLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_wndLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_wndLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_wndLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_wndLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_wndLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_wndLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_wndLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_wndLyt_styleContentBigImage() {
				return contentVals => {
					return contentVals.bigImage
				}
			},
			$_wndLyt_styleContentBigImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_wndLyt_styleContentBigImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			},
			$_wndLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_wndLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_wndLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		}
	}
</script>

<style scoped>
	.row_ {
		margin-bottom: -24px;
	}
	.flat_.v-carousel {
		box-shadow: none;
	}
</style>
